var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-icons-fav"},[(!_vm.favList.length)?_c('el-alert',{staticClass:"m-icons-tips",attrs:{"title":"没有收藏的图标，请搜索图标进行添加。","type":"info","center":"","show-icon":""}}):_c('div',{staticClass:"m-icons-matrix"},_vm._l((_vm.favList),function(icon,index){return _c('icon-item',{key:index,attrs:{"icon":icon,"isFav":true}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }